import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

const MyButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#F8F7F9",
  textTransform: "uppercase",
  color: "#591A68",
  borderRadius: "0",
  border: "0",
  display: "flex",
  //   padding: "6px 0",
  justifyContent: "space-between",
  alignItems: "center",
  //   letterSpacing: "2px",
  [theme.breakpoints.up("xs")]: {
    letterSpacing: "8px",
    padding: "12px 0",
  },
  [theme.breakpoints.up("md")]: {
    letterSpacing: "2px",
    padding: "6px 0",
  },
  fontWeight: "900",
  "&:hover": {
    backgroundColor: "#F8F7F9",
  },
}));

const MyButtonYellow = styled(Button)(({ theme }) => ({
  backgroundColor: "#EDAD4D",
  textTransform: "uppercase",
  color: "#591A68",
  borderRadius: "0",
  border: "0",
  display: "flex",
  //   padding: "6px 0",
  justifyContent: "space-between",
  alignItems: "center",
  //   letterSpacing: "2px",
  [theme.breakpoints.up("xs")]: {
    letterSpacing: "3px",
    padding: "12px 0",
  },
  [theme.breakpoints.up("md")]: {
    letterSpacing: "2px",
    padding: "6px 0",
  },
  fontWeight: "900",
  "&:hover": {
    backgroundColor: "#EDAD4D",
  },
}));
export { MyButton, MyButtonYellow };
